import React from "react";
import SvgIconDPC from "../dpc-svg-icon";

export default class DpcNavbar extends React.Component {


    getHomepagePath = () => {
        let item = this.props.menuItems?.find(item => item.title.toLowerCase() === 'homepage');
        if (item) {
            return item.link;
        }
        return '/';
    }

    render() {
        return (
            <div className="it-header-navbar-wrapper">
                <div className="container">
                    <div className="px-custom">
                        <nav className="navbar navbar-expand-xl has-megamenu" aria-label="Menu principale">
                            <button className="custom-navbar-toggler" type="button" aria-controls="navMain"
                                    aria-expanded="false" aria-label="Toggle navigation" data-target="#navMain"
                                    title="Navigazione menu principale">
                                <SvgIconDPC name={'burger'}/>
                            </button>

                            <div className="navbar-collapsable" id="navMain">
                                <div className="overlay"/>

                                <div className="menu-wrapper">
                                    <div className="close-div">
                                        <button className="btn close-menu" type="button" title="Chiudi menu">
                                            <SvgIconDPC name={'close'}/>
                                        </button>
                                    </div>

                                    <ul className="navbar-nav">
                                        <li className="nav-item nav-homepage">
                                            <a className="nav-link" href={this.getHomepagePath()}
                                               title="Homepage"><span>Homepage</span></a>
                                        </li>

                                        { 
                                            this.props.menuItems.filter(item => item.title.toLowerCase() !== 'homepage').sort((a, b) => {
                                                return a.weight > b.weight ? 1 : -1;
                                            }).map((item, i) => {
                                                return (
                                                    <>
                                                    {item.children?.length > 0 ?
                                                    <li className={`nav-item dropdown megamenu ${item.active ? "active" : ""}`}>
                                                        <a className={`nav-link dropdown-toggle ${item.active ? "active" : ""}`}
                                                           href={item.link ? item.link : `#`}
                                                           data-toggle="dropdown"
                                                           aria-expanded="false">
                                                            <span>{item.title}</span>

                                                            <SvgIconDPC name={'expand'} classiAggiuntive={"icon-sm"}/>
                                                        </a>

                                                        
                                                                <div className="dropdown-menu">
                                                                    <div className="row">
                                                                        <div class="col-12 col-lg-4">
                                                                            <div className="link-list-wrapper">
                                                                                <ul className="link-list">
                                                                                    {
                                                                                        item.children.sort((a, b) => {
                                                                                            return a.weight > b.weight ? 1 : -1;
                                                                                        }).map(child => {
                                                                                                return (
                                                                                                    <li className={`${child.active ? "active" : ""}`}>
                                                                                                        <a className="list-item"
                                                                                                        href={child.link}><span>{child.title}</span></a>
                                                                                                    </li>
                                                                                                )
                                                                                            }
                                                                                        )
                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            
                                                        

                                                    </li>
                                                    :
                                                    <li className={`nav-item`}>
                                                        <a className={`nav-link`}
                                                        href={item.link ? item.link : `#`}
                                                        aria-expanded="false">
                                                            <span>{item.title}</span>                                                      
                                                        </a>
                                                    </li>
                                                    }
                                                    </>
                                                )
                                            })
                                        }
                                    </ul>

                                    <h4 className="social-title">{this.props.lang === 'it' ? 'Seguici su' : 'Follow us'}</h4>

                                    <ul className="list-inline text-left social">
                                              <li className="list-inline-item marginTTNavbarAD">                 
                                             <a href="https://www.tiktok.com/@attimodecisivo?_t=ZN-8xszCgoxDDq&_r=1"
                                                title="Segui la campagna di Attimo decisivo su TikTok"
                                                target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'tiktok'} color={"#fff"} className={'customIconTTNavbarAD'}/>
                                                <span className="sr-only">TikTok</span>

                                            </a>
                                            </li> 

                                            <li className="list-inline-item">
                                                <a href="https://www.instagram.com/attimodecisivo/?igsh=MWcxd2lkNGZsZDRnYQ%3D%3D"
                                                title="Profilo della campagna Io non rischio su Instagram"
                                                target="_blank" rel="noreferrer">
                                                    <SvgIconDPC name={'instagram'}/>

                                                <span className="sr-only">Instagram</span>
                                                </a>
                                            </li>

                                            <li className="list-inline-item">
                                                <a href="https://www.youtube.com/@attimodecisivo"
                                                title="Canale YouTube della campagna Io non rischio"
                                                target="_blank" rel="noreferrer">
                                                    <SvgIconDPC name={'youtube'}/>

                                                <span className="sr-only">YouTube</span>
                                                </a>
                                            </li>
                                     
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        );
    }

}
